import { render, staticRenderFns } from "./FooterItem.vue?vue&type=template&id=5946f990&scoped=true&"
import script from "./FooterItem.vue?vue&type=script&lang=js&"
export * from "./FooterItem.vue?vue&type=script&lang=js&"
import style0 from "./FooterItem.vue?vue&type=style&index=0&id=5946f990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946f990",
  null
  
)

export default component.exports